module.exports = __webpack_public_path__ + "img/28.04ad5217.jpg";